import { render } from "./Emoji.vue?vue&type=template&id=68f4d2f7"
import script from "./Emoji.vue?vue&type=script&lang=js"
export * from "./Emoji.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__